import { useQuery } from "@tanstack/react-query";
import { QueryKey } from "./constants";
import api, { baseUrl } from "../services/api";

export const useCountries = () => {
  const queryKey = [QueryKey.Countries];

  const queryFn = async () => {
    const URL = `${baseUrl}/countries`;

    const { data } = await api.get(URL);

    return data;
  };

  return useQuery({
    queryKey: queryKey,
    queryFn: queryFn,
  });
};
